import React, { useEffect } from "react";

export default function CustomCssLoader({ href }) {
  useEffect(() => {
    if (!href) return;
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = href;
    link.dataset.cms = "custom-css";
    document.head.appendChild(link);
    return () => {
      const node = document.head.querySelector('link[data-cms="custom-css"]');
      if (node) node.remove();
    };
  }, [href]);

  return null;
}
